import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Row, Col, Tooltip, Divider } from 'antd';
import CardListSummaryHolder from "./Styles/cardListSummaryStyle";
import 'moment/locale/es';
import 'moment/locale/en-gb';
import NumberFormat from './NumberFormat';
import ImageListModal from './ImageListModal';

const CardListSummaryComponent = (props) => {
  const { t } = useTranslation();
  const { campaign } = props;
  const [visibleSpotModal, setVisibleSpotModal] = useState(false);
  const [selectedDisplay, setSelectedDisplay] = useState(null);

  const showSpotModal = (display) => {
    setSelectedDisplay(display);
    setVisibleSpotModal(true);
  };

  const handleDisplayModal = () => {
    setVisibleSpotModal(!visibleSpotModal);
  };

  const groupedByDisplays = useMemo(() => {
    if (!campaign.contents_displays) {
      return [];
    }

    return campaign.contents_displays.reduce((acc, item) => {
      let displayGroup = acc.find(group => group.id === item.display_id);

      if (!displayGroup) {
        displayGroup = {
          id: item.display_id,
          name: item.display_name,
          listContent: [],
          totalPaid: 0,
          currency: campaign.currency
        };
        acc.push(displayGroup);
      }

      displayGroup.totalPaid += Number(item.paid_amount_with_profit);
      displayGroup.listContent.push({
        id: item.content_id,
        name: item.content_name,
        file: item.content_file_thumb,
        type: item.content_type
      });

      return acc;
    }, []);
  }, [campaign.contents_displays]);

  return (
    <CardListSummaryHolder>
      <div className="cardListSummary">
        <Row justify="center">
          <Col className={"text-title"}>{t("Summary")}<br /></Col>
          <Col>
            <div className='titleInfo'>{t("Campaign name")}</div>
            <div className='infoDate'>{campaign.name}</div>
          </Col>
          <Col className='listContent'>
            {groupedByDisplays.map((display) => {
              return (
                <div key={display.id} className='content'>
                  <Tooltip title={display.name}>
                    <div className='titleInfo'>{display.name}</div>
                  </Tooltip>
                  <div className='infoDateTwo'>
                    <span onClick={() => showSpotModal(display)}>
                      <Icon type="eye-o" />
                    </span>
                    {display.totalPaid &&
                      <NumberFormat value ={display.totalPaid.toFixed(2)} currency={campaign.currency}/>
                    }
                  </div>
                  <Divider />
                </div>
              )
            })}
          </Col>
        </Row>
      </div>
      {selectedDisplay && (
        <ImageListModal
          visibleSpotModal={visibleSpotModal}
          handleDisplayModal={handleDisplayModal}
          selectedDisplay={selectedDisplay}
        />
      )}
    </CardListSummaryHolder>
  );
};

export default CardListSummaryComponent;
